import { render, staticRenderFns } from "./homepage-business.vue?vue&type=template&id=70923753&"
import script from "./homepage-business.vue?vue&type=script&lang=js&"
export * from "./homepage-business.vue?vue&type=script&lang=js&"
import style0 from "./homepage-business.vue?vue&type=style&index=0&id=70923753&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports